<template>
  <div class="content-wrap">

    <div class="search-wrap">
      <div class="row">
        <div class="col-md-3">
          <div class="mb-3">
            <ElLabel name="이름">
              <template #end="{id}">
                <ElInput :id="id" v-model="state.searchParams.usr_nm"  @inputKeyupEnter="getDataList"/>
              </template>
            </ElLabel>

            
          </div>
        </div>
        <div class="col-md-3">
          <div class="mb-3">

            <ElLabel name="회사">
              <template #end="{id}">
                <ElInput :id="id" v-model="state.searchParams.cmp_nm" @inputKeyupEnter="getDataList"/>
              </template>
            </ElLabel>

          </div>
        </div>
        <div class="col-md-3">
          <div class="mb-3">
            <ElLabel name="휴대폰번호">
              <template #end="{id}">
                <ElInput :id="id"  phoneNumber
                :modelValue="state.searchParams.mobile" 
                @update:modelValue="getMobileMask" 
                @inputKeyupEnter="getDataList"/>
              </template>
            </ElLabel>
          </div>
        </div>
        <div class="col-md-3">
          <div class="mb-3">
            <ElLabel name="영업대표">
              <template #end="{id}">
                <ElInput :id="id" v-model="state.searchParams.sales_boss" @inputKeyupEnter="getDataList"/>
              </template>
            </ElLabel>

          </div>
        </div>
      </div>
    </div>
    <div class="search-detail-wrap"></div>

    <div class="text-end py-2">
      <ElButton type="search" @buttonClick="getDataList()">검색</ElButton>
    </div>

    <div class="d-flex justify-content-between">
      <div></div>
      <div class="table-btn-group">
        <img src="/images/vr.png" alt="">
        <ElButton type="excelDownload" @buttonClick="excelDown()">엑셀다운</ElButton>
      </div>
    </div>
    <div class="table-responsive table-list">
      <DataTable 
        v-model:selection="state.selectedRow" 
        :value="state.gridRowData"
        selectionMode="single"
        @rowSelect="onRowSelect"
        removableSort
        scrollable
        scrollHeight="300px"
        paginator 
        :rows="20" 
        :rowsPerPageOptions="[10, 20, 50, 100, 200]" 
      >
        <template #empty>
          <div class="center">데이터가 존재하지 않습니다.</div>
        </template>
        <Column>
          <template #header>
              <ElCheckbox v-model="allCheck"/>
          </template>
          <template #body="{ data }">
              <ElCheckbox 
              v-model="state.selectedRow" 
              :value="data"
              />
          </template>
        </Column>

        <Column>
          <template #header>
            <ElButton
                  type='bookmarkS'
                  disabled
            ></ElButton>
          </template>
          <template #body="{ data }">
            <ElButton
                    type='bookmarkS'
                    disabled
                    :active="data.bkmark_yn == 'Y'"
              ></ElButton>
          </template>
        </Column>

        <Column v-for="(notice,index) of state.gridColumn" :key="index" :field="notice.field" :header="notice.headerName"
          :sortable="notice.sortable" :style="notice.style">
      
        <template #body="{ data,field }">
          <span v-if="field == 'trend_nm'" :class="getOptionStyle(data.trend_nm)">{{ data.trend_nm }}</span>
          <span v-else-if="field == 'cmp_nm'||field == 'cmp_dvsn_nm'||field == 'event_nm'">{{ getSummaryData(data[field]) }}</span>
          <span v-else-if="field == 'sales_boss'">{{ getSummaryDataShort(data.sales_boss) }}</span>
          <span v-else>{{ data[field] }}</span>
        </template>
        </Column>
      </DataTable>
    </div> {{ vue }}

    <div v-for="row in rows" :key="row.text">
      {{ row.text }}
    </div>

    <div class="text-end">
      <ElButton  v-if="canUpdate" @buttonClick="$router.push('/sm/MSM_SA_004')" type="primary">신규등록</ElButton>
      <ElButton type="primary" @buttonClick="openEmailModal">공유하기</ElButton>      
    </div>
  </div>

  <!-- @return="data => getExcelData(data)"   -->
  <div>
    <ExcelManage ref="excelManageRef" v-show="false">
    </ExcelManage>
  </div>
  <ExcelUploadModal
  ref="excelUploadModalRef"
  :colDefs="state.gridColumn"
  />
  <EmailSendModal ref="emailSendModalRef" />
</template>

<script setup>

import { reactive, ref, onBeforeMount, computed } from 'vue'
import ExcelManage from '@/components/common/MCO_EX_001.vue'
import { useRouter } from "vue-router";
import common from '@/js/common';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import vueRouterCmn from '@/js/vueRouterCmn';
import ExcelUploadModal from '@/components/common/modal/ExcelUploadModal.vue';
import EmailSendModal from '@/components/common/modal/EmailSendModal.vue';
import { useLoading } from '@/composable/Loading.js'
const { setIsLoading } = useLoading()
import { leadList } from '@/api/lead';
const router = useRouter();
const cellPhone1 = ref(null);
const cellPhone2 = ref(null);
const emailSendModalRef = ref()
const excelUploadModalRef = ref()
//setup 함수는 컴포넌트 인스턴스가 생성되기 전에 실행
onBeforeMount(() => {
  getDataList()
})

//수정권한으로 row클릭시 상세조회/수정페이지 이동 분기처리
const canUpdate = computed(()=>{
    return common.checkAccessAuth('M002M002M001')
})

//모바일 형식  (010-0000-0000)  
const getMobileMask = (mobile) => {

  state.searchParams.mobile = common.phoneFormat(mobile)

}

const getSummaryData = (item) => {

let summaryData = item.length > 10 ? item.slice(0, 10) + " ..." : item;

return summaryData
}

const getSummaryDataShort = (item) => {

let summaryData = item.length > 7 ? item.slice(0, 6) + " ..." : item;

return summaryData
}

const excelManageRef = ref()

//변수 선언 영역 
const state = reactive({
  selectedRow: [],
  //컬럼 셋팅
  gridColumn: [
    { headerName: '이름', field: "usr_nm", style: { textAlign : 'center',minWidth: "100px",maxWidth: "100px",textOverflow:'ellipsis', whiteSpace:'nowrap', overflow:'hidden'},sortable:true },
    { headerName: '휴대폰', field: "mobile", style: { minWidth: "150px" },sortable:true},
    { headerName: '이메일', field: "email", style: { minWidth: "120px" },sortable:true},
    { headerName: '회사', field: "cmp_nm", style: { minWidth: "150px" },sortable:true },
    { headerName: '사업부', field: "cmp_dvsn_nm", style: { minWidth: "150px" },sortable:true },
    { headerName: '직책', field: "postion", style: { minWidth: "150px" },sortable:true },
    { headerName: '관심분야', field: "attn_nm", style: { minWidth: "150px" },sortable:true },
    { headerName: '산업분야', field: "indst_nm", style: { minWidth: "150px" },sortable:true },
    { headerName: '영업대표', field: "sales_boss", style: { textAlign : 'center', minWidth: "100px" },sortable:true },
    { headerName: '이벤트명', field: "event_nm", style: { minWidth: "150px" },sortable:true },
    { headerName: '성향', field: "trend_nm", style: { textAlign:"center",minWidth: "150px" },sortable:true },
    { headerName: '영업기회ID', field: "sales_id", style: { minWidth: "150px" },sortable:true },
    { headerName: '등록일자', field: "fmt_reg_dt", style: { textAlign : 'center',minWidth: "120px" },sortable:true },
  ],
  excelGridColumn: [
    { headerName: "즐겨찾기", field: "bkmark_yn" },
    { headerName: '이름', field: "usr_nm"},
    { headerName: '휴대폰', field: "mobile"},
    { headerName: '이메일', field: "email"},
    { headerName: '회사', field: "cmp_nm"},
    { headerName: '사업부', field: "cmp_dvsn_nm"},
    { headerName: '직책', field: "postion"},
    { headerName: '관심분야', field: "attn_nm"},
    { headerName: '산업분야', field: "indst_nm"},
    { headerName: '영업대표', field: "sales_boss"},
    { headerName: '이벤트명', field: "event_nm"},
    { headerName: '성향', field: "trend_nm"},
    { headerName: '영업기회ID', field: "sales_id",},
    { headerName: '등록일자', field: "fmt_reg_dt"},
  ],
  gridRowData: [],
  searchParams: {
    usr_nm: '',
    // cmp_info_seq : '',
    cmp_nm: '',
    mobile: '',
    sales_boss: '',
    page_count: 1,
    unit_count: 100000,
  },

});

const allCheck = computed({
  get() {
    return state.gridRowData.length === state.selectedRow.length;
  },
  set(newValue) {
    state.selectedRow = newValue ? state.gridRowData.map((item) => { return item }) : [];
  }
})

const getOptionStyle = (item) => {
  const stageValue = item
  let classNm = ''
  if (stageValue == 'Positive') {
    classNm = 'text-in text-positive';
  } else if (stageValue == 'Negative') {
    classNm = 'text-in text-negative';
  } else if (stageValue == 'Unknown' || stageValue == 'Unknow') {
    classNm = 'text-in text-unknown';
  } else if (stageValue == 'Neutral') {
    classNm = 'text-in text-neutral';
  }
  return classNm
}

//엑셀 다운로드
const excelDown = async () => {
  let fileNm = '리드 리스트'
  let header = [...state.excelGridColumn]
  let dataList = state.gridRowData
  if (state.selectedRow?.length > 0) {
    dataList = state.selectedRow
  }

  excelManageRef.value.excelDownload(fileNm, header, dataList)
}



const getDataList = async () => {
  try {
    setIsLoading(true)
    const res = await leadList(state.searchParams)
    state.gridRowData = res.rtn;
    console.log("res",res)
  } catch (err) {
    console.error(err)
    alert("조회 중 에러가 발생하였습니다.");
  } finally {
    setIsLoading(false)
  }

};

const onRowSelect = (lead) => {
  if(canUpdate.value){
    vueRouterCmn.routerPush('MSM_SA_006', { ld_seq: lead.data.ld_seq })
  }else{
    vueRouterCmn.routerPush('MSM_SA_011', { ld_seq: lead.data.ld_seq })
  }
}

function openEmailModal(){
  const emailParams = {
    call_prgm_id : 'MSM_SA_005',
    call_prgm_nm : '리드 조회/수정',
    receiver_ids : '',
    receiver_nms : '',
    title : '리드 정보 공유드립니다.',
    content : makeEmailContent()
  };
  emailSendModalRef.value.openEmailModal(emailParams)
}

/** 메일발송 모달 (4.메일내용) */
const makeEmailContent = () => {
  //선택된 회사의 목록
  let content = '';

  for (let lead of state.selectedRow) {
    content += `<b>이름</b>: ${lead.usr_nm || ''}<br>`
            +`<b>휴대폰</b>: ${lead.mobile || ''}<br>`
            +`<b>이메일</b>: ${lead.email || ''}<br>`
            +`<b>회사</b>: ${lead.cmp_nm || ''}<br>`
            +`<b>사업부</b>: ${lead.cmp_dvsn_nm || ''}<br>`
            +`<b>직책</b>: ${lead.postion || ''}<br>`
            +`<b>관심분야</b>: ${lead.attn_nm || ''}<br>`
            +`<b>산업분야</b>: ${lead.indst_nm || ''}<br>`
            +`<b>이벤트명</b>: ${lead.event_nm || ''}<br>`
            +`<b>영업대표</b>: ${lead.sales_boss || ''}<br>`
            +`<b>성향</b>: ${lead.trend_nm || ''}<br>`
            +`===================================================<br><br>`;  
  }
  return content;

  //메일 내용 만들기

}


</script>